import Vue from 'vue'
import Vuex from 'vuex'
import ls from 'local-storage'
import cookie from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    CUSUT: null, //登录用户签名
    userInfo: null, //登录用户信息
    menuList: null, //菜单
    priviList: null, //权限
    contractGray: false, //合同灰度标记 (名单内主办走合同流程; 随菜单接口刷新, 不持久化, 关灰度后刷新即回退)
    benefitTicketGray: false, //权益票白名单标记 (business_config benefit_ticket_whitelist; 随菜单接口刷新, 不持久化)
    taskList: [],//上传任务
    posterAudit: null,//海报 LLM 审核结果 (评判内存: {texts, times, price, time})
    companyName: '北京太合乐人文化艺术有限公司', //公司名称（页脚版权公用）
    icpNumber: '京ICP备190031801号-2', //ICP备案号
  },
  mutations: {
    setCUSUT(state,data){
      state.CUSUT = data;
      cookie.set('CUSUT',data);
    },
    setUserInfo(state,data){
      state.userInfo = data;
      ls.set('userInfo',data);
    },
    setMenuList(state, data) {
      state.menuList = data;
      ls.set('menuList',data);
    },
    setPriviList(state,data){
      state.priviList = data;
      ls.set('priviList',data);
    },
    setContractGray(state,data){
      state.contractGray = !!data; // 只进内存, 刷新后由 getMenu 重新拉取, 保证关灰度即回退
    },
    setBenefitTicketGray(state,data){
      state.benefitTicketGray = !!data; // 只进内存, 刷新后由 getMenu 重新拉取, 保证白名单调整即生效
    },
    logOut(state){
      state.CUSUT = null;
      state.userInfo = null;
      state.menuList = null;
      state.posterAudit = null; //清海报审核结果, 防换号登录残留上一用户数据
      cookie.remove('CUSUT');
      ls.remove('userInfo');
      ls.remove('menuList');
    },
    //上传任务
    SET_TASKLIST: (state, data) => {
      state.taskList = data;
    },
    //海报 LLM 审核结果 (评判内存)
    SET_POSTER_AUDIT: (state, data) => {
      state.posterAudit = data;
    },
  },
  actions: {
    //上传任务
    setTaskList({commit}, task) {
      commit('SET_TASKLIST', task);
    },
  },
  modules: {
  }
})
